import PropTypes from 'prop-types';
import React from 'react';
import SearchBarTerm from './SearchBarTerm';
import styles from './SearchBar-style.scss';
import { createSearchLink } from './searchBarHelpers';

const SearchBarSection = ({ urlSection, title, terms, handleRowClick }) => (
    <div className={styles.section}>
        <div className={styles.header}>{title}</div>
        {terms.map(({ term, urlLabel }) => {
            const href = createSearchLink(term, urlSection, urlLabel);
            return (
                <SearchBarTerm
                    key={term}
                    term={term}
                    href={href}
                    handleRowClick={handleRowClick}
                />
            );
        })}
    </div>
);

SearchBarSection.propTypes = {
    title: PropTypes.string,
    terms: PropTypes.array,
    urlSection: PropTypes.string,
    handleRowClick: PropTypes.func
};

export default SearchBarSection;



// WEBPACK FOOTER //
// ./src/components/SearchBar/SearchBarSection.jsx